import { ServiceResult } from '../models/api-shared.models';
import ApiService from './api-service';

class SalesPortalService extends ApiService {
  private static classInstance: SalesPortalService;

  private constructor() {
    super('SalesPortal');
  }

  public getSalesPortalUrl(): ServiceResult<{ Url: string }> {
    return this.post(`${this.baseUrl}/GetSalesPortalUrl`, undefined);
  }

  public getProductRecommendationsUrl(): ServiceResult<{ Url: string }> {
    return this.post(`${this.baseUrl}/GetProductRecommendationsUrl`, undefined);
  }

  public static getInstance(): SalesPortalService {
    if (!this.classInstance) {
      this.classInstance = new SalesPortalService();
    }
    return this.classInstance;
  }
}

export default SalesPortalService;
